export enum MultiVinVisibilityScope {
  FullVisibility = 'platform_full',
  InventoryOnly = 'inventory_only'
}

export interface GeneratedLeaseOfferDraft {
  paymentAmount: string | null;
  moneyDown: string | null;
  percentageDown: string | null;
  term: number | null;
  annualMileage: number | null;
  additionalText: string | null;
  isCustom: boolean;
}

export interface GeneratedFinanceOfferDraft {
  paymentAmount: string | null;
  moneyDown: string | null;
  percentageDown: string | null;
  apr: string | null;
  term: number | null;
  additionalText: string | null;
  isCustom: boolean;
}

export interface GeneratedAprOfferDraft {
  apr: string | null;
  term: number | null;
  additionalText: string | null;
  useDefaultSettings: boolean;
}

export interface GeneratedOfferSetDraft {
  multiVinVisibility: MultiVinVisibilityScope;
  lease: GeneratedLeaseOfferDraft;
  alternateLease: GeneratedLeaseOfferDraft;
  finance: GeneratedFinanceOfferDraft;
  promotionalApr: GeneratedAprOfferDraft;
}
